import { ORDERS_FILTER_DATA_KEY } from '~/types';
import { textValueOf } from '~/types/filters';
import {
  newOrderFilterRowId,
  operatorsForField,
  type OrderFilterConnector,
  type OrderFilterRow,
} from '~/pages/orders/lib/orderFilters';

export type SavedOrderFilterRow = {
  field: string;
  operator: string;
  value: string;
  connector?: string;
};

export type OrderFilterData = {
  orderFilters: SavedOrderFilterRow[];
};

export function rowsToFilterData(rows: OrderFilterRow[]): OrderFilterData {
  return {
    [ORDERS_FILTER_DATA_KEY]: rows.map((row) => ({
      field: row.field,
      operator: row.operator,
      value: textValueOf(row),
      connector: row.connector,
    })),
  };
}

function isSavedRow(entry: unknown): entry is SavedOrderFilterRow {
  if (typeof entry !== 'object' || entry === null) return false;
  const candidate = entry as Record<string, unknown>;
  return (
    typeof candidate.field === 'string' &&
    typeof candidate.operator === 'string' &&
    typeof candidate.value === 'string'
  );
}

function connectorOf(entry: SavedOrderFilterRow): OrderFilterConnector {
  return entry.connector === 'or' ? 'or' : 'and';
}

export function toFilterRows(raw: unknown): OrderFilterRow[] {
  if (!Array.isArray(raw)) return [];

  const rows: OrderFilterRow[] = [];
  for (const entry of raw) {
    if (!isSavedRow(entry)) continue;
    const operators = operatorsForField(entry.field);
    if (operators === null || !operators.includes(entry.operator)) continue;
    rows.push({
      id: newOrderFilterRowId(),
      field: entry.field,
      operator: entry.operator,
      value: entry.value,
      connector: connectorOf(entry),
    });
  }
  return rows;
}

export function readOrderFilterRows(filterData: unknown): OrderFilterRow[] {
  if (typeof filterData !== 'object' || filterData === null) return [];
  return toFilterRows(
    (filterData as Record<string, unknown>)[ORDERS_FILTER_DATA_KEY]
  );
}
